import React, { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";

export default function WalletSend() {
  const { user, refresh } = useAuth();
  const [to, setTo] = useState("");
  const [amount, setAmount] = useState("");
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);

  const doPreview = async () => {
    if (!to.trim() || !amount) return toast.error("أدخل المستلم والمبلغ");
    try { setPreview(await api("/wallet/p2p/preview", { method: "POST", body: JSON.stringify({ to: to.trim(), amount: Number(amount) }) })); }
    catch (e) { toast.error(e.message); }
  };
  const doTransfer = async () => {
    setBusy(true);
    try {
      await api("/wallet/p2p/transfer", { method: "POST", body: JSON.stringify({ to: to.trim(), amount: Number(amount) }) });
      toast.success("تم التحويل بنجاح"); refresh(); setTo(""); setAmount(""); setPreview(null);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  return (
    <div className="animate-fade-in-up max-w-lg mx-auto">
      <PageHeader title="تحويل رصيد" subtitle={`رصيدك: ${Number(user?.wallet_balance || 0).toFixed(2)} د.ل`} backTo="/wallet" />
      <p className="text-sm font-bold mb-1.5">المستلم (المعرّف @ أو رقم المستخدم)</p>
      <input data-testid="p2p-to" value={to} onChange={(e) => setTo(e.target.value)} placeholder="@user123" className="w-full bg-white rounded-xl px-4 py-3 border border-[#E8EAF2] outline-none focus:ring-2 focus:ring-[#FF3D5A]" />
      <p className="text-sm font-bold mt-4 mb-1.5">المبلغ (د.ل)</p>
      <input data-testid="p2p-amount" type="number" value={amount} onChange={(e) => { setAmount(e.target.value); setPreview(null); }} className="w-full bg-white rounded-xl px-4 py-3 border border-[#E8EAF2] outline-none focus:ring-2 focus:ring-[#FF3D5A]" />
      {!preview ? (
        <button data-testid="p2p-preview" onClick={doPreview} className="w-full h-12 rounded-2xl bg-[#161629] text-white font-black mt-5">معاينة التحويل</button>
      ) : (
        <div className="mt-5">
          <div className="p-4 bg-white rounded-2xl border border-[#E8EAF2] space-y-1.5 text-sm">
            <div className="flex justify-between"><span className="text-[#6B7280]">المستلم</span><span className="font-black">{preview.recipient?.name || preview.recipient?.store_name}</span></div>
            <div className="flex justify-between"><span className="text-[#6B7280]">المبلغ</span><span className="font-black">{Number(preview.amount).toFixed(2)} د.ل</span></div>
            <div className="flex justify-between"><span className="text-[#6B7280]">الرسوم</span><span className="font-black">{Number(preview.fee || 0).toFixed(2)} د.ل</span></div>
            <div className="flex justify-between border-t pt-2"><span className="text-[#161629] font-black">الإجمالي المخصوم</span><span className="font-black text-[#FF3D5A]">{Number(preview.total || 0).toFixed(2)} د.ل</span></div>
          </div>
          <button data-testid="p2p-transfer" disabled={busy} onClick={doTransfer} className="w-full flex items-center justify-center gap-2 h-13 py-4 rounded-2xl bg-[#FF3D5A] text-white font-black mt-4 disabled:opacity-60"><Send size={18} /> {busy ? "..." : "تأكيد التحويل"}</button>
        </div>
      )}
    </div>
  );
}
